<template>
  <div
    ref="box"
    class="cont_section"
  >
    <!-- S : 공통 타이틀 영역 -->
    <mpn-section-title
      :anchor-id="anchorId"
    >
      {{ title }}
      <template slot="additional">
        <span
          v-if="showTotal"
          class="right_position_item"
        >
          <p class="quantity_info">
            총 <em :style="computedColor">{{ totalPillsPerPocket }}</em> 정/<span>캡슐</span>
          </p>
        </span>
      </template>
    </mpn-section-title>
    <!-- E : 공통 타이틀 영역 -->

    <!-- S : 제품정보 리스트 -->
    <div class="product_list_wrap">
      <ul class="img_list chk_type">
        <template
          v-for="(item, index) in productGroup"
        >
          <product-item
            ref="productItem"
            :key="index"
            :item="item"
            :checkbox="checkbox"
            :event-bus="eventBus"
            @change="onProductChoiceChanged"
            @dose-change="onDoseChanged"
          />
        </template>
      </ul>
    </div>
    <!-- E : 제품정보 리스트 -->
  </div>
</template>
<script>
import { log } from '@/utils/common';
import ProductItem from './ProductItem.vue';

export default {
  name: 'ProductSection',
  components: {
    ProductItem,
  },
  props: {
    title: {
      type: String,
      default: 'name me',
    },
    productGroup: {
      type: Array,
      default: () => [],
    },
    checkbox: {
      type: Boolean,
      default: false,
    },
    eventBus: {
      type: Object,
      default: null,
    },
    anchorId: {
      type: String,
      default: 'anchor me',
    },
    showTotal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedItems: [],
    };
  },
  computed: {
    totalPillsPerPocket() {
      let totalPills = 0;
      this.productGroup.forEach((n) => {
        totalPills += n.selectedCount;
      });
      return totalPills;
    },
    computedColor() {
      return this.totalPillsPerPocket > 12 ? 'color: red' : '';
    },
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
  },
  methods: {
    onScroll() {
      const VISIBLE_THRESHOLD = 300;
      const INVISIBLE_THRESHOLD = 259;
      const el = this.$refs.box;
      const { top, bottom } = el.getBoundingClientRect();
      if (top < VISIBLE_THRESHOLD
      && bottom > INVISIBLE_THRESHOLD) {
        // console.log(this.productGroup[0].category, 'visible');
        this.$emit('visible', {
          groupCode: this.productGroup[0].category,
          visible: true,
        });
      } else {
        // console.log(this.productGroup[0].category, 'invisible');
        this.$emit('visible', {
          groupCode: this.productGroup[0].category,
          visible: false,
        });
      }
    },
    onProductChoiceChanged(params) {
      this.$emit('checkExclusive', params);
      if (params.checked) {
        this.addCheckedProduct(params);
      } else {
        this.removeUncheckedProduct(params);
      }

      this.$emit('input', this.selectedItems.slice());
    },
    setItemState(params) {
      const { item_sku, selected, count } = params;
      log('composition-ProductSection::setItemState', this.$refs, this.$refs.productItem);
    },

    addCheckedProduct(prd) {
      const item = this.selectedItems.find((n) => n.item_sku === prd.item_sku);
      if (item) {
        item.selectedCount = prd.selectedCount;
      } else {
        this.selectedItems.push(prd);
      }
    },
    removeUncheckedProduct(prd) {
      const idx = this.selectedItems.findIndex((n) => n.item_sku === prd.item_sku);
      if (idx > -1) {
        this.selectedItems.splice(idx, 1);
      }
    },
    onDoseChanged(prd) {
      this.$emit('dose-change', prd);
    },
  },
};
</script>

<style scoped>

.img_list >>> li .quantity {
  min-width: 204px;
}

</style>
